import { useMemo } from "react"

import { FEATURE_FLAGS, useFeatureFlagValue } from "@/feature-flags"

import type { NavigationFeatureFlag } from "../types"

export function useNavigationFeatureFlagStatus(): Partial<
  Record<NavigationFeatureFlag, boolean>
> {
  const isBenchmarksEnabled = useFeatureFlagValue(FEATURE_FLAGS.BENCHMARKS)
  const isHumanReviewRoleModesEnabled = useFeatureFlagValue(
    FEATURE_FLAGS.HUMAN_REVIEW_ROLE_MODES,
  )
  const isSofiaNotebooksEnabled = useFeatureFlagValue(
    FEATURE_FLAGS.SOFIA_NOTEBOOKS,
  )

  return useMemo(
    () => ({
      [FEATURE_FLAGS.BENCHMARKS]: !!isBenchmarksEnabled,
      [FEATURE_FLAGS.HUMAN_REVIEW_ROLE_MODES]: !!isHumanReviewRoleModesEnabled,
      [FEATURE_FLAGS.SOFIA_NOTEBOOKS]: !!isSofiaNotebooksEnabled,
    }),
    [
      isBenchmarksEnabled,
      isHumanReviewRoleModesEnabled,
      isSofiaNotebooksEnabled,
    ],
  )
}
